import { render, staticRenderFns } from "./CategoriesView.vue?vue&type=template&id=f3d308d4&scoped=true"
import script from "./CategoriesView.vue?vue&type=script&lang=js"
export * from "./CategoriesView.vue?vue&type=script&lang=js"
import style0 from "./CategoriesView.vue?vue&type=style&index=0&id=f3d308d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3d308d4",
  null
  
)

export default component.exports